import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Master Core Java, JSP, Servlet, Hibernate, Maven, Spring, and more with our comprehensive tutorials and guides. Start learning today!
        </p>
        <a
          className="App-link"
          href="https://basics-in-java.blogspot.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://basics-in-java.blogspot.com/
        </a>
      </header>
    </div>
  );
}

export default App;
